module.exports = __webpack_public_path__ + "static/media/Admin.6ea37f17.svg";